<div class="row">
    <ng-container *ngFor="let payment of payments">
        <div class="col-md-6 col-lg-4 col-xxl-4 col-xxxl-3 animated-col">
            <div class="payment-card ccc ccc-hover" (click)="navigateToDetailHandler(payment.paymentId)" role="button">
                <div HJSuppress class="payment-number">
                    <dynamic-field [props]="props?.Number" [canBeEmpty]="true">
                        <div class="d-flex align-items-center justify-content-center">
                            <span class="text-ellipsis">
                                {{payment?.number}}
                            </span>                
                            <button class="btn copy-clipboard-btn custom-copy-clipboard-btn ms-2" 
                                [cdkCopyToClipboard]="payment.number" 
                                (click)="showClipboardNotification($event)">
                                <i class="app-icon icon icon-copy icon-md2"></i>
                            </button>
                        </div>
                    </dynamic-field>
                </div>
                <div class="payment-issue-date">
                    <dynamic-field [props]="props?.Date" [canBeEmpty]="true">
                        {{'payment.date' | translate}}:
                        <span HJSuppress>
                            {{payment?.date | localizedDate}}
                        </span>
                    </dynamic-field>
                </div>
                <div class="payment-value">
                    <dynamic-field [props]="props?.Value" [canBeEmpty]="true">
                        {{'payment.value' | translate}}
                        <span HJSuppress class="value">
                            {{payment?.value | number : '1.'}} {{payment?.currencyCode}}
                        </span>
                    </dynamic-field>
                </div>
                <div class="payment-method">
                    <dynamic-field [props]="props?.Type" [canBeEmpty]="true">
                        {{'payment.type' | translate}}
                        <span HJSuppress class="value">
                            {{payment?.type}}
                        </span>
                    </dynamic-field>
                </div>
            </div>
        </div>
    </ng-container>
</div>